// Updates the accordion metafield values on variant change

(function () {
  if (window.ckVariantInfoLoaded) return;
  window.ckVariantInfoLoaded = true;

  function getVariantId(output) {
    const section = output.closest('.shopify-section') || document;

    const variantInput =
      section.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      section.querySelector('form[action*="/cart/add"] select[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    return variantInput ? variantInput.value : null;
  }

  function updateOutput(output, variantId) {
    const valueElement = output.querySelector('[data-variant-value]');
    const mapElement = output.querySelector('[data-variant-map]');

    if (!valueElement || !mapElement || !variantId) return;

    let variantValues;

    try {
      variantValues = JSON.parse(mapElement.textContent);
    } catch {
      return;
    }

    const value = variantValues[String(variantId)];

    if (value === null || value === undefined || value === '') {
      valueElement.textContent = '';
      output.hidden = true;
      return;
    }

    if (output.dataset.variantContentType === 'richtext') {
      valueElement.innerHTML = value;
    } else {
      valueElement.textContent = value;
    }

    output.hidden = false;
  }

  function updateAccordionVisibility() {
    const accordions = [];

    document
      .querySelectorAll('[data-hide-empty-accordion]')
      .forEach(function (content) {
        const fields = content.querySelectorAll(
          '[data-variant-value], [data-material-value]'
        );

        const hasContent = Array.from(fields).some(function (field) {
          return field.textContent.trim() !== '';
        });

        const accordion = content.closest('accordion-disclosure');

        if (accordion) {
          accordion.hidden = !hasContent;
          accordions.push(accordion);
        }
      });

    let firstVisibleFound = false;

    accordions.forEach(function (accordion) {
      if (accordion.hidden) return;

      accordion.classList.toggle('ck-accordion--first-visible', !firstVisibleFound);
      firstVisibleFound = true;
    });
  }

  function updateVariantInfo(variantId) {
    document
      .querySelectorAll('[data-variant-output]')
      .forEach(function (output) {
        updateOutput(output, variantId || getVariantId(output));
      });

    updateAccordionVisibility();
  }

  document.addEventListener('variant:change', function (event) {
    const variantId =
      event.detail?.variant?.id ||
      event.detail?.variantId;

    updateVariantInfo(variantId);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('quantity-selector')) return;

    const selector = event.target.closest(
      'variant-selects, variant-radios, form[action*="/cart/add"]'
    );

    if (selector) {
      updateVariantInfo();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateVariantInfo();
  });

  document.addEventListener('shopify:section:load', function () {
    updateVariantInfo();
  });
})();
